import { motion } from "framer-motion";
import { ArrowRight, Briefcase } from "lucide-react";
import { Link } from "react-router-dom";

const ease = [0.16, 1, 0.3, 1];

export const Careers = () => (
  <section
    id="candidatures"
    data-testid="careers-section"
    className="bg-cream py-16 lg:py-20 border-t border-border"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease }}
        className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8"
      >
        <div className="flex items-start gap-5">
          <span className="w-12 h-12 border border-charcoal/15 flex items-center justify-center flex-shrink-0">
            <Briefcase className="w-5 h-5 text-charcoal" strokeWidth={1.25} />
          </span>
          <div>
            <span className="text-bronze text-xs uppercase tracking-[0.25em]">Carrières</span>
            <h3 className="mt-2 font-serif text-charcoal text-2xl sm:text-3xl leading-snug font-normal">
              Vous cherchez un emploi ? <span className="italic text-bronze">Rejoignez la famille DEM BAT.</span>
            </h3>
            <p className="mt-3 text-charcoal/60 text-sm sm:text-base font-light max-w-xl">
              Nous conservons toutes les candidatures et vous recontactons lors de nos prochains recrutements.
            </p>
          </div>
        </div>
        <Link
          to="/candidatures"
          data-testid="careers-section-link"
          className="group inline-flex items-center justify-center gap-3 border border-charcoal text-charcoal hover:bg-charcoal hover:text-white px-8 py-4 text-xs uppercase tracking-[0.25em] transition-colors duration-300 self-start lg:self-auto"
        >
          Candidatures ici
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
        </Link>
      </motion.div>
    </div>
  </section>
);
